var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layoutFooter"},[_vm._v(" Copyrights © 2019 - 2023 All Rights Reserved. 版权所有 甘肃省融资担保集团股份有限公司 陇ICP备17005709号 设计制作 宏点网络 "),_c('img',{attrs:{"src":"https://www.gsrzdb.cn/hdimg/bas/images/ga.png","alt":""}}),_vm._v(" 甘公网安备 62010202002786号 甘公网安备 62010202002786号 ")])
}]

export { render, staticRenderFns }